import BossModel from "@/models/BossModel";
import User from '@/models/User/User'
import Proposal from "@/models/Proposal/Proposal";

export default class OccurredEvent extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'proposal/occurred-event';

    /**
     *
     * @type {string}
     */
    static entity = 'proposalOccurredEvents';

    static EVENTS =  [
        {id: 1, name: 'Offerte aanmaken'},
        {id: 8, name: 'Marge controle'},
        {id: 9, name: 'Marge geaccepteerd'},
        {id: 3, name: 'Marge geweigerd'},
        {id: 10, name: 'Verstuurd naar klant'},
        {id: 11, name: 'Klant akkoord'},
        {id: 74, name: 'Wijziging aangevraagd'},
        {id: 72, name: 'Klant akkoord (door medewerker)'},
        {id: 73, name: 'Medewerker akkoord'},
        {id: 13, name: 'IATA controle'},
        {id: 5, name: 'IATA controle geaccepteerd'},
        {id: 6, name: 'IATA controle geweigerd'},
        {id: 14, name: 'Aanvraag naar agents'},
        {id: 140, name: 'Agent controle afgerond'},
        {id: 15, name: 'Boeking akkoord'},
        {id: 16, name: 'Product controle'},
        {id: 51, name: 'Product controle geaccepteerd'},
        {id: 52, name: 'Product controle geweigerd'},
        {id: 17, name: 'Voucher gegenereerd'},
        {id: 18, name: 'E-ticket gegenereerd'},
        {id: 19, name: 'Gepubliceerd op mijn voor de klant'},
        {id: 30, name: 'Agent akkoord'},
        {id: 40, name: 'CFS geweigerd'},
        {id: 50, name: 'Voorstel geannuleerd'},
        {id: 98, name: 'Annulering afgerond'},
        {id: 100, name: 'DIGI oude orders voltooid'},
        {id: 101, name: 'Factuur verstuurd'},
        {id: 102, name: 'CFS controle afgerond'},
        {id: 103, name: 'Voorstel gevalideerd'},
    ];

    static fields() {
		return {
			id: this.attr(null),
			proposal_event_cid: this.attr(null),
			user_id: this.attr(null),
			created_at: this.attr(null),
			proposal_id: this.attr(null),
            user: this.belongsTo(User, 'user_id'),
            proposal: this.belongsTo(Proposal, 'proposal_id'),
		}
	}

    /**
     *
     * @returns {string|*}
     */
    name() {
        return this.constructor.name(this.proposal_event_cid);
    }

    static name(proposalEventCid) {
        let eventType = this.EVENTS.find(event => event.id == proposalEventCid);
        if (eventType === undefined) {
            return 'Onbekend (' + proposalEventCid + ')';
        }

        return eventType.name;
    }

    /**
     *
     * @param proposalId
     * @returns {*}
     */
    static loadByProposal(proposalId) {
        return this.api()
            .where('proposal_id', proposalId)
            .limit(0)
            .get(true);
    }

    static loadByDossier(dossierId){
        return this.api()
            .where('dossier_id', dossierId)
            .limit(0)
            .get(true);

    }

    isRequestChangesEvent(){
        return this.proposal_event_cid === 74;
    }

    isAgentRequestedEvent(){
        return this.proposal_event_cid === 14;
    }

}
